import React from "react";
import submit from "submit-form";
import SvgIcon from "../../../../parts/SvgIcon";

export const PendingTabCoachComponent = ({ locals, isAdminOrOwner }) => {
  const { usersOrganization } = locals;
  const { organizationPendingUsers = [] } = usersOrganization;

  /**
   * Delete forever from the organization
   * @param {*} e
   * @param {*} userId
   * @param {*} isAdminOrOwner
   */
  const deleteCoach = (e, userId, isAdminOrOwner) => {
    if (isAdminOrOwner && userId) {
      e.stopPropagation();
      e.preventDefault();
      if (
        process.browser &&
        confirm("Are you sure you want to delete this coach?")
      ) {
        submit(`/actions/organizations/delete-user`, {
          method: "POST",
          body: {
            userId,
          },
        });
      }
    }
  };

  /**
   * Send the email's invitation again
   * @param {*} e
   * @param {*} email
   * @param {*} isAdminOrOwner
   */
  const resendInvite = (e, email, isAdminOrOwner) => {
    if (isAdminOrOwner && email) {
      e.stopPropagation();
      e.preventDefault();

      submit("/actions/organizations/resend-code", {
        method: "POST",
        body: {
          email,
        },
      });
    }
  };

  return organizationPendingUsers.map((item) => {
    const { name = "", email = "", _id = "" } = item;

    return (
      <li key={_id}>
        <article>
          <div className="left pending">
            <SvgIcon
              src="/img/new-icons/user-circle.svg"
              alt="pending"
              className="avatar pending"
            />

            <div className="coach-info">
              <p className="p4">{email}</p>
            </div>
          </div>
          <div className="right">
            {isAdminOrOwner && (
              <a
                role="button"
                data-button-type="outline"
                onClick={(e) => {
                  resendInvite(e, email, isAdminOrOwner);
                }}
              >
                <span>Resend Invite</span>
              </a>
            )}
            {isAdminOrOwner && (
              <button
                data-button-type="secondary"
                data-action="cancel"
                disabled={isAdminOrOwner ? undefined : true}
                onClick={(e) => {
                  deleteCoach(e, _id, isAdminOrOwner);
                }}
              >
                Remove
              </button>
            )}
          </div>
        </article>
      </li>
    );
  });
};
